export function AutoUnsubscribe(constructor: any) {
    // Save the original ngOnDestroy method
    const originalNgOnDestroy = constructor.prototype.ngOnDestroy;

    // Override ngOnDestroy to handle the destroy$ subject
    constructor.prototype.ngOnDestroy = function () {
        console.log(`[${constructor.name}] ngOnDestroy called`);

        // Emit and complete the destroy$ subject if it exists
        if (this.destroy$) {
            this.destroy$.next();
            this.destroy$.complete();
        }

        // Call the original ngOnDestroy method if it exists
        if (originalNgOnDestroy) {
            originalNgOnDestroy.apply(this, arguments);
        }
    };
}





